import styled from 'styled-components';

export const AppContainers = styled.div`
  & > div {
    flex: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: calc(2vmin);
    color: white;
  }

  @media (min-width: 960px) {
    background-color: ${(props) => props.theme.headerBg};
    max-height: 5vh;
    display: flex;
    border-bottom: 1px solid #000;

    & > div.headerLogo {
      flex: 2;
      min-width: 150px;
      /* opacity: 0; */
      justify-content: left;
    }
    & > div.headerMainTitle {
      flex: 4;
    }
    & > div.headerTitle {
      flex: 4;
    }
    & > div.headerClock {
      flex: ${(props) => props.theme.clockFlex};
    }
    & > nav.headerButtons {
      flex: 0.9;
      justify-content: flex-end;
    }
  }

  @media (max-width: 960px) {
    background-color: ${(props) => props.theme.headerBg};
    min-height: 6vh;
    display: flex;
    border-bottom: 1px solid #000;
    flex-wrap: wrap;
    align-content: stretch;

    & > div.headerLogo {
      flex: 2;
      min-width: 150px;
      justify-content: center;
    }
    & > div.headerClock {
      display: block;
    }
    & > nav.headerButtons {
      flex: 0.9;
    }
  }
`;
